export const MODE_DEFAULT = "async";
export const SCOPE_DEFAULT = "body";
